import { Component, OnDestroy, OnInit } from "@angular/core";
import { notifications } from "app/core/notifications/notifications";
import { Subscription } from "rxjs";
import { NotificationService } from "../services/notification.service";

@Component({
  selector: "app-notification-sidebar",
  templateUrl: "./notification-sidebar.component.html",
  styleUrls: ["./notification-sidebar.component.scss"],
})
export class NotificationSidebarComponent implements OnDestroy {
  isOpen = false;
  tabs = [];
  notificationSub: Subscription;
  notifications = notifications;

  constructor(private notificationService: NotificationService) {
    this.notificationSub = this.notificationService.changeEmitted$.subscribe(
      (key) => this.toggleNotification(true, key)
    );
  }

  toggleNotification(show: boolean, tab: string) {
      if (show) {
      this.tabs = [...this.tabs, tab];
    } else {
      this.tabs = this.tabs.filter((t) => t !== tab);
    }
    if (this.tabs.length === 0) {
      this.isOpen = false;
    } else {
      this.isOpen = true;
    }
  }

  ngOnDestroy() {
    if (this.notificationSub) {
      this.notificationSub.unsubscribe();
    }
  }
}
